import { AloftPrice, isDefined, schAlertType, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { PropertyGridCellKey } from '../../../../components/PropertyGrid/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';
import { getCompTypeLabel, getScopedAlertType } from '../utils/compTypeScoping.ts';

const TARGET_CELL_TOOLTIP = 'Adjustments all in the same direction';
const TIPS =
  'Include Comps with positive and negative adjustments, or explain the one-sided adjustment trend.';

export const allCompsAdjustedSame: AlertDefinition = ({
  compAdjustments,
  compSequence,
  compType,
  order,
}) => {
  const netAdjustments = compSequence
    .map((id) => compAdjustments[id]?.netAdjustment.adjustment)
    .filter(isDefined);

  const allSameDirection =
    netAdjustments.length > 0 &&
    (netAdjustments.every((netAdjustment) => netAdjustment.gt(AloftPrice.zero)) ||
      netAdjustments.every((netAdjustment) => netAdjustment.lt(AloftPrice.zero)));

  if (compSequence.length < 2 || !allSameDirection) return [];

  let message: string;
  switch (compType) {
    case 'aiv':
    case 'arv':
      message = `All ${getCompTypeLabel(compType)} Comparables are adjusted in the same direction.`;
      break;
    default:
      message = 'All Comps are adjusted in the same direction.';
      break;
  }

  const fixRoute = schPairedCostRouteItem.enum['adjustments-grid'];
  const firstCompId = compSequence[0];
  const targetCellKey = `${firstCompId}-adjustedSalePrice` as PropertyGridCellKey;

  return [
    {
      type: getScopedAlertType(schAlertType.enum.allCompsAdjustedSame, compType),
      status: 'active',
      severity: 'error',
      orderType: ['appraisify'],
      message,
      propertyID: firstCompId,
      ...(compType ? { compType } : {}),
      fixingInfo: {
        tips: TIPS,
        pairedCostRouteItem: fixRoute,
        fixingMethod: ['comment', 'action'],
        commentAlwaysRequired: false,
        targetCellKey,
        targetCellTooltip: TARGET_CELL_TOOLTIP,
      },
      triggers: getAlertTriggers({
        fixRoute,
        order,
        includeUpdate: true,
      }),
    },
  ];
};
